import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classname';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../components/table/main';
import Form from '../components/form/small/main';
import Search from '../../shared/search/main';
import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/filters/main';
import SwitchControlSingleDecorator from  '../../shared/switch-control/single/main';

import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(
	props =>
		<Animate>
			<div className="container__content news-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('News')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="news-list__form-position">
						<Form {...props} className="small" initialValues={props.formData.initialValues} enableReinitialize={true} />
					</div>
					<div className="news-list__filter-position clearfix">
						<Filters {...props} {...props.filters} />
					</div>

					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---search">
							<div className="ui-control-bar__item-position">
								<Search
									form="newsSearchForm"
									action={props.search}
									{...props}
									autoFocus={true}
									initialValues={props.searchData} />
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<SwitchControlSingleDecorator>
									{props.quickFilters.map((filter, id) => (
										<button
											key={id}
											className={cn({
												'active': filter.active,
												'ui-btn ui-btn-secondary': true
											})}
											onClick={() => props.applyQuickFilter(filter.name)}
										>
											{props.intl(filter.placeholder)}
										</button>
									))}
								</SwitchControlSingleDecorator>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								{props.formData &&
								!props.formData.showForm &&
								<button className="ui-btn ui-btn-primary add-news" onClick={props.showForm}>
									{props.intl('Add news')}
								</button>}

								<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>{props.intl('Apply')}</button>
								<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
							</div>
						</div>
					</div>

					<div className="news-list__table-position">
						<Table {...props} />
					</div>
				</div>
			</div>
		</Animate>,
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		searchData: selectors.getSearchData(state),
		quickFilters: selectors.getQuickFilters(state),
		filters: selectors.getFilters(state),
		formData: selectors.getFormData(state),
		formLangs: selectors.getFormTabLangs(state),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/list/main.js